export const environment = {
  production: false,
  ApiUrl: 'https://uatsite-45f9fccbb93a-tasheelapi-uat.procco.net/api/',
  ImageUrl: 'https://uatsite-45f9fccbb93a-tasheelapi-uat.procco.net/',
  CheckoutPublicKey: 'pk_sbox_jnxi2iisvkgzyt2pwyi3acinx42',
  isLogRocketEnabled: false,
  logRocketId: 's9covv/tasheel-uat-web',
  GoogleTagProd: false,
  version: '1.8',
  isOpenBankingEnabled: false,
  leanAppToken: 'eb78f7c0-90fb-4abf-b35f-e2b42d621a4b',
  useLeanSandbox: true,
  UteUrl: 'https://ute.procco.net/',
  firebaseAppId: '1:727251600875:web:59748d583a3844c92e85ae',
  showPromoCodeNonPF : false,
  showPromoCodePF : true,
  baseetaAppQRCode : 'assets/images/Illustrations/baseeta-qr-code-uat.webp',
  baseetaAndroid : 'https://play.google.com/store/apps/details?id=com.procco.baseeta',
  baseetaIOS : 'https://apps.apple.com/sa/app/baseeta-split-it-your-way/id6502289375',
  isTracingEnabled : false,
  isRoutingTraceEnabled: false,
  calculateEligibilityFirst : true,
  isTomiAiEnabled : true,
  checkGeoLocation : true
};
